/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { listingManagementActionType as actions, awsTokenActionType } from '~constants/actionTypes';
import { pmsEndpoints } from '~settings/endpoints';
import { fetch } from '~actions/pms-actions/shared';
import * as queries from '~settings/pms-queries';
import { message } from 'antd';
import i18n from '~settings/i18n';

export const setProperty = payload => ({
  type: actions.SET_PROPERTY,
  payload: payload.property,
});

// this function overrides the existing property.
export const overrideProperty = payload => ({
  type: actions.SET_PROPERTY,
  payload: payload.property,
  override: true,
});

export const setGalleryProperty = payload => ({
  type: actions.SET_GALLERY_PROPERTY,
  payload: payload.property,
});

export const getPropertyDetail =
  (slug, successCallback = () => {}, draftSize) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.getPropertyDetail.url(),
      params: queries.getPropertyDetail({ slug, draftSize }),
      communicationType: actions.GET_PROPERTY_CS,
      successAction: overrideProperty,
      onSuccess: res => {
        successCallback(res);
        dispatch({
          type: actions.SET_GALLERY_PROPERTY,
          payload: res.property,
        });
      },
      onError: e => {
        if (e && e[0] && e[0].message === 'invalid node id.') {
          message.error(i18n.t('cms:cms.properties.edit.toast.error.property_not_exist'));
        } else {
          message.error(i18n.t('cms:cms.properties.edit.toast.error'));
        }
      },
    });
  };

export const publishProperty =
  (params, successCallback = () => {}, errCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.publishProperty.url(),
      params: queries.publishProperty(params),
      communicationType: actions.PUBLISH_PROPERTY_CS,
      onSuccess: data => {
        const { status, error, description } = data.publishProperty;
        if (status === 'FAILED') {
          if (error === 'PROPERTY_CITY_UNPUBLISHED') {
            message.error(
              i18n.t('cms:cms.properties.edit.detail.city.state_invalid', {
                invalid: description,
              }),
            );
          } else {
            message.error(i18n.t('cms:cms.properties.edit.toast.error'));
          }
          return;
        }
        if (successCallback) {
          successCallback();
        }
      },
      onError: (errors, code) => {
        if (
          (params.publish &&
            errors &&
            errors[0] &&
            errors[0].message.indexOf('VALIDATE_PAYMENT_PLAN_FAIL') !== -1) ||
          (code && code.indexOf('VALIDATE_PAYMENT_PLAN_FAIL') !== -1)
        ) {
          errCallback();
        } else if (errors?.[0]?.extensions?.code === 'LISTING_AVAILABILITY_SET_TO_NULL') {
          message.error(i18n.t('cms:cms.properties.edit.publish.listing_error'));
        } else {
          message.error(i18n.t('cms:cms.properties.edit.toast.error'));
        }
      },
    });
  };

export const getPropertyPreview =
  (slug, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.getGeneralUrl.url(),
      params: queries.getPropertyPreview({ slug }),
      communicationType: actions.GET_PROPERTY_PREVIEW_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: e => {
        if (e && e[0] && e[0].message === 'invalid node id.') {
          message.error(i18n.t('cms:cms.properties.edit.toast.error.property_not_exist'));
        } else {
          message.error(i18n.t('cms:cms.properties.edit.toast.error'));
        }
      },
    });
  };

export const deleteRoom =
  (id, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.deleteRoom.url(),
      params: queries.deleteRoom({ id }),
      communicationType: actions.DELETE_ROOM_CS,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const createRoom =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.createRoom.url(),
      params: queries.createRoom(params),
      communicationType: actions.CREATE_ROOM_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const updateRoom =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.updateRoom(params),
      communicationType: actions.UPDATE_ROOM_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const setCopyRoomListing = params => ({
  type: actions.SET_COPY_ROOM_LISTING,
  payload: params,
});

export const createListing =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.createListing(params),
      communicationType: actions.CREATE_LISTING_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const updateListing =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.updateListing(params),
      communicationType: actions.UPDATE_LISTING_CS,
      onSuccess: successCallback,
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const deleteListing =
  (id, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.deleteListing({ id }),
      communicationType: actions.DELETE_LISTING_CS,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const bulkUpdateListings =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.bulkUpdateListings(params),
      communicationType: actions.BULK_UPDATE_LISTING_CS,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const bulkDeleteListings =
  (ids, successCallback = () => {}, errorCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.bulkDeleteListings({ ids }),
      communicationType: actions.BULK_DELETE_LISTING_CS,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
        errorCallback();
      },
    });
  };

export const updateListingAdminSetting =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.updateListingAdminSetting(params),
      communicationType: actions.UPDATE_LISTING_ADMIN_SETTING_CS,
      onSuccess: () => {
        successCallback();
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const updateGallery =
  (params, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.updateGallery(params),
      communicationType: actions.UPDATE_GALLERY_CS,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };

export const checkVideoUploaded = (videoHash, successCallback) => dispatch => {
  fetch({
    dispatch,
    endpoint: pmsEndpoints.checkVideoUploaded.url(),
    params: queries.checkVideoUploaded({ videoHash }),
    communicationType: awsTokenActionType.CHECK_VIDEO_UPLOADED,
    onSuccess: data => {
      successCallback(data);
    },
    onError: () => {
      message.error(i18n.t('cms:cms.properties.edit.toast.error'));
    },
  });
};

export const getUploadVideoToken = successCallback => dispatch => {
  fetch({
    dispatch,
    endpoint: pmsEndpoints.getUploadVideoToken.url(),
    params: queries.getUploadVideoToken(),
    communicationType: awsTokenActionType.GET_UPLOAD_VIDEO_TOKEN,
    onSuccess: data => {
      successCallback(data);
    },
    onError: () => {
      message.error(i18n.t('cms:cms.properties.edit.toast.error'));
    },
  });
};

export const createVideo = (param, successCallback) => dispatch => {
  fetch({
    dispatch,
    endpoint: pmsEndpoints.createVideo.url(),
    params: queries.createVideo(param),
    communicationType: awsTokenActionType.CREATE_VIDEO,
    onSuccess: data => {
      successCallback(data);
    },
    onError: () => {
      message.error(i18n.t('cms:cms.properties.edit.toast.error'));
    },
  });
};

export const getUnitTypeFacilities =
  (successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.defaultUrl.url(),
      params: queries.queryUnitTypeFacilities(),
      communicationType: actions.GET_UNIT_TYPE_FACILITIES,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms.properties.edit.toast.error'));
      },
    });
  };
